export default class HorizontalList extends HTMLElement {}

customElements.define("horizontal-list", HorizontalList);
